import JotformPage from "@components/Jotform/JotformPage";
import Loading from "@components/layout/Loading";
import { auth, db } from "@utils/firebase";
import getFormId from "@utils/forms";
import { useGetUser } from "@utils/hooks";
import { doc, setDoc } from "firebase/firestore";
import React, { useEffect, useState, useRef } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";

type FactFindQualificationProps = {};

const FactFindQualification: React.FC<FactFindQualificationProps> = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const { data: userData, isLoading: userLoading, refetch } = useGetUser();
  const [getQualifiendLoading, setGetQualifiedLoading] = useState(false);
  const hasSubmittedRef = useRef(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const navigationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const { mutate, isLoading: mutationLoading } = useMutation({
    mutationFn: async () => {
      if (!user?.uid) throw new Error("No user ID");

      const user_ref = doc(db, "users", user.uid);
      console.log("FactFindQualification: Updating database");

      return await setDoc(
        user_ref,
        {
          form_qualification: true,
        },
        { merge: true }
      );
    },
    onSuccess: async () => {
      console.log("FactFindQualification: Database update successful");
      setGetQualifiedLoading(true);

      // Start polling for user data updates
      intervalRef.current = setInterval(() => {
        console.log("FactFindQualification: Polling for user data updates");
        refetch();
      }, 1500);

      // Set a safety timeout for navigation
      navigationTimeoutRef.current = setTimeout(() => {
        console.log("FactFindQualification: Navigation timeout triggered");
        setGetQualifiedLoading(false);
        navigate("/fact-find/qualification/message");
      }, 10000);
    },
    onError: (error) => {
      console.error("FactFindQualification: Error updating database", error);
      setGetQualifiedLoading(false);
      hasSubmittedRef.current = false;
    }
  });

  const handleFormSubmit = () => {
    if (hasSubmittedRef.current) return;

    console.log("FactFindQualification: Form submitted");
    hasSubmittedRef.current = true;
    mutate();
  };

  // Check for user data updates and navigate when ready
  useEffect(() => {
    if (!userLoading && userData?.is_tax_resident) {
      console.log("FactFindQualification: User data updated, navigating");

      // Clear intervals and timeouts
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (navigationTimeoutRef.current) {
        clearTimeout(navigationTimeoutRef.current);
      }

      setGetQualifiedLoading(false);
      navigate("/fact-find/qualification/message");
    }
  }, [navigate, userData, userLoading]);

  // Clean up on unmount
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (navigationTimeoutRef.current) {
        clearTimeout(navigationTimeoutRef.current);
      }
    };
  }, []);

  if (mutationLoading || userLoading || getQualifiendLoading) {
    return <Loading />;
  }

  return (
    <JotformPage
      formId={getFormId("qualification")}
      onSubmit={handleFormSubmit}
    />
  );
};

export default FactFindQualification;
